import React from 'react'
import FooterSection from '../FooterSection'
import WeWorkPerHourFAQ from './components/FaqDetails'

const Faq = () => {
  return (
  <div>
     <WeWorkPerHourFAQ/>
     <FooterSection />
  </div>
  )
}

export default Faq